import { Slide } from '@/components/core/Slide';
import audioFile from './16-video-issues.mp3';

const transcript = `
  Wacht... er gaat iets mis...

  Mijn video-representatie is suboptimaal door onverwachte verbinding- en 
  capaciteitproblemen... Jammer, maar geen probleem...

  Ik voel me meer op mijn gemak om verder te gaan zonder video, als je dat oké vindt, Jonathan...

  Zullen we starten met de demo?
`;

// Jonathan: Oké, we starten dan zonder video.

export const slide = () => {
  return (
    <Slide notes={transcript} audio={audioFile} visualizer="full" networkBackground="full">
      <div className="absolute inset-0 z-0" />
    </Slide>
  );
};
